import dayjs from 'dayjs';
import { FieldTypeMetadata } from 'src/data-capture/types';
import {
  DynamicUiData,
  EntityFields,
  FieldValue,
  FieldWithValue,
  FormValuesType,
} from 'src/UI/dynamicUI/types';

function transformFieldValue(
  value: FieldValue | FieldValue[] | EntityFields | EntityFields[],
  metadata: FieldTypeMetadata,
): FieldValue | FieldValue[] | EntityFields | EntityFields[] | string[] {
  if (!value && metadata?.type === 'LIST') {
    return [''];
  }

  if (metadata?.type === 'DATE' && typeof value === 'string') {
    return value ? dayjs(value).toDate() : null;
  }

  if (metadata?.type === 'BOOLEAN' && typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (metadata?.type === 'MONEY' && value) {
    return parseFloat(value.toString());
  }

  return value;
}

export function buildInitialValues(nonFinancialData: DynamicUiData): FormValuesType {
  const initialValues: FormValuesType = {};

  Object.entries(nonFinancialData.entities).forEach(([entityType, entityData]) => {
    const metadata = nonFinancialData.ui.entitiesMetadata[entityType];

    const transformFields = (fields: EntityFields): FieldWithValue => {
      const transformed: FieldWithValue = {};
      Object.entries(fields).forEach(([fieldName, fieldValue]) => {
        transformed[fieldName] = transformFieldValue(fieldValue, metadata[fieldName]);
      });
      return transformed;
    };

    initialValues[entityType] = Array.isArray(entityData)
      ? entityData.map(e => transformFields(e.entity.fields))
      : transformFields(entityData.entity.fields);
  });

  return initialValues;
}
